
import React, { Component } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {
    Redirect, Route,
    Switch
} from 'react-router-dom';
import Login from './components/pages/Login';
import Overview from './components/pages/Overview';
import { Welcome } from './components/pages/Welcome';
import { UserProvider } from './UserContext';


class App extends Component {

    render() {
        return (
            <UserProvider value={this.user}>
                <Switch>
                    <Route path="/login" component={Login} />
                    <Route path="/overview" component={Overview} />

                    <Route
                        path="/welcome"
                        render={({ name }) => <Welcome name={"React"} />}
                    />

                    <Redirect from="/" to="/overview" />
                </Switch>
            </UserProvider>
        )
    }
}

export default App;
